





































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { SoundSettingvalues } from "@/services/settings";
import { DEFAULT_SOUND_VOLUME } from "@/services/constants";

@Component({})
export default class SoundControl extends Vue {
  radio: SoundSettingvalues = SoundSettingvalues.ON;
  soundVolume = DEFAULT_SOUND_VOLUME;
  isEditSoundVolume = false;

  get soundOn(): string {
    return SoundSettingvalues.ON;
  }

  get soundVolumeControlerLabel(): string {
    return `音量 (${this.soundVolume * 100}%)`;
  }

  get soundOff(): string {
    return SoundSettingvalues.OFF;
  }

  created() {
    this.radio = this.$store.state.soundSetting;
    this.soundVolume = this.$store.state.soundSettingVolume;
  }

  @Watch("radio")
  onChangeSoundSetting() {
    this.$store.commit("setSoundSetting", this.radio);
  }

  @Watch("soundVolume")
  onChangeSoundSettingVolume() {
    this.$store.commit("setSoundSettingVolume", this.soundVolume);
  }
  get showVolumeContorol(): boolean {
    return this.radio === SoundSettingvalues.ON;
  }
  get editSoundVolumeButtonLabel(): string {
    return this.isEditSoundVolume ? "音量変更 非表示" : "音量を変更する";
  }
}
